import { emotionTheme } from '@styles/theme'
import {
  ArrowCounterClockwiseIcon,
  CheckCircleIcon,
  CheckSquareOffsetIcon,
  MinusCircleIcon,
  SpinnerIcon
} from '@phosphor-icons/react'

import { PreviewsStatus, type BigNumbersPreviewItemProps, type BudgetPreviewsStatusProps } from './types'

import * as S from './styles'

export const getPreviewStatusConfig = (status: BigNumbersPreviewItemProps) => {
  const statusMap = {
    [PreviewsStatus.NOT_STARTED]: {
      icon: <MinusCircleIcon size={18} />,
      label: status.descriptionPtbr || 'Não iniciado',
      color: emotionTheme.colors.secondary,
      background: emotionTheme.colors.gray[300]
    },
    [PreviewsStatus.IN_PROGRESS]: {
      icon: <SpinnerIcon size={18} />,
      label: status.descriptionPtbr || 'Em Andamento',
      color: emotionTheme.colors.yellow[500],
      background: emotionTheme.colors.yellow[100]
    },
    [PreviewsStatus.RELEASED]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Liberada',
      color: emotionTheme.colors.blue.dark,
      background: emotionTheme.colors.blue.head
    },
    [PreviewsStatus.RELEASED_SEND]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Liberada Envio',
      color: emotionTheme.colors.blue.dark,
      background: emotionTheme.colors.blue.head
    },
    [PreviewsStatus.GCE_VALIDATION]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação GCE',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.GO_VALIDATION]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação GO',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.GO_VALIDATION_COMPLETED]: {
      icon: <CheckCircleIcon size={18} />,
      label: status.descriptionPtbr || 'Validada GO',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    },
    [PreviewsStatus.RETURNED_GCE]: {
      icon: <ArrowCounterClockwiseIcon size={18} />,
      label: status.descriptionPtbr || 'Devolvida GCE',
      color: emotionTheme.colors.error.color,
      background: emotionTheme.colors.error.background
    },
    [PreviewsStatus.RETURNED_GU]: {
      icon: <ArrowCounterClockwiseIcon size={18} />,
      label: status.descriptionPtbr || 'Devolvida GU',
      color: emotionTheme.colors.error.color,
      background: emotionTheme.colors.error.background
    },
    [PreviewsStatus.CONTROLLER_VALIDATION]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação Controller',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.RETURNED_CONTROLLER]: {
      icon: <ArrowCounterClockwiseIcon size={18} />,
      label: status.descriptionPtbr || 'Devolvida Controller',
      color: emotionTheme.colors.error.color,
      background: emotionTheme.colors.error.background
    },
    [PreviewsStatus.DIRECTOR_VALIDATION]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação Diretor',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.DIRECTOR_VALIDATION_COMPLETED]: {
      icon: <CheckCircleIcon size={18} />,
      label: status.descriptionPtbr || 'Validada Diretor',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    },
    [PreviewsStatus.HEAD_FINANCE_VALIDATION]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação Financeiro',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.RETURNED_HEAD_FINANCE]: {
      icon: <ArrowCounterClockwiseIcon size={18} />,
      label: status.descriptionPtbr || 'Devolvida Financeiro',
      color: emotionTheme.colors.error.color,
      background: emotionTheme.colors.error.background
    },
    [PreviewsStatus.VP_APPROVAL]: {
      icon: <CheckSquareOffsetIcon size={18} />,
      label: status.descriptionPtbr || 'Em validação VP',
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    [PreviewsStatus.COMPLETED]: {
      icon: <CheckCircleIcon size={18} />,
      label: status.descriptionPtbr || 'Finalizada',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    },
    [PreviewsStatus.COMPLETED_GO_VALIDATION]: {
      icon: <CheckCircleIcon size={18} />,
      label: status.descriptionPtbr || 'Validada GO',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    }
  }

  return statusMap[status.code as keyof typeof statusMap]
}

export const BudgetPreviewsStatus = ({ status, compact }: BudgetPreviewsStatusProps) => {
  const statusConfig = getPreviewStatusConfig(status)

  return (
    <S.Container compact={compact}>
      <S.Content
        compact={compact}
        style={{
          color: statusConfig?.color ?? emotionTheme.colors.secondary,
          background: statusConfig?.background ?? emotionTheme.colors.gray[300]
        }}
      >
        {statusConfig?.label ?? status.descriptionPtbr ?? '—'}
        {!compact && statusConfig?.icon}
      </S.Content>
    </S.Container>
  )
}
